import React, { useState, useEffect, useCallback, useContext } from "react";
import getAllRecruitersResponsetab from "../../apis/recruiters/getAllRecruiterstab";
import approveRecruitersResponse from "../../apis/recruiters/approveRecruiters";
import AllRevokedRecruitersKendoTable from "./AllRevokedRecruitersKendoTable";

import { NotificationManager } from "react-notifications";
import AllNotApprovedRecruitersKendoTable from "./AllNotApprovedRecruitersKendoTable";
import AllapprovedRecruitersKendoTable from "./AllapprovedRecruitersKendoTable";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import getAllActiveRecruitmentpartner from "../../apis/organization/getAllActiveRecruitmentpartner";
import getActiveRoles from "../../apis/users/getActiveRoles";
import { getAgencyType } from "../../apis/agency/agencyApi";
import getAgencyByAgencytypeResponse from "../../apis/recruiters/getAgencyByAgencytype";
import { UserTypeContext } from "../../AppRoute";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { useNavigate } from "react-router-dom";
import Excel from "../../components/Icons/excel";
import "./recruiters.css";
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess.js";
const stylesSX = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  waitingText: {
    marginLeft: '5px',
  },
});


const filterOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option) => option.name,
});

const Recruiters = ({ idContextTest }) => {
  const history = useNavigate();
  const { userType, userRecords } = useContext(UserTypeContext);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [allapprovedRecruiters, setallapprovedRecruiters] = useState([]);
  const [allNotApprovedRecruiters, setallNotApprovedRecruiters] = useState([]);
  const [allRevokedRecruiters, setallRevokedRecruiters] = useState([]);
  const [tabName, settabName] = useState("Pending");
  const [openApproveDialogue, setOpenApproveDialogue] = useState(false);
  const [openRevokeDialogue, setOpenRevokeDialogue] = useState(false);
  const [recruiterData, setRecruiterData] = useState({});
  const [userRole, setUserRole] = useState([]);
  const [AllOrganization, setAllOrganization] = useState([]);
  const [email, setEmail] = useState("");
  const [agencies, setAgencies] = useState([]);
  const [agencyTypeData, setAgencTypeData] = useState([]);
  const [selectAgencyType, setSelectAgencyType] = useState("");
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [RecruitmentParterId, setRecruitmentParterId] = useState("");
  const [apvBtn, setApvBtn] = useState(false);
  const [recruiterInfo, setrecruiterInfo] = useState({
    agencyId: "",
    patnerId: "",
    orgCode: "",
  })
  const [totalCount, setTotalCount] = useState(0)

  const [filterValue, setFilterValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userRole: {},
    organizationName: {}
  })
  const [isExporting, setIsExporting] = useState(false);
  const [paginationState, setPaginationState] = useState({
    page: 1,
    pageSize: 10,
  })
  const [appliedFilter, setAppliedFilter] = useState({})

  // ------ Getting all active roles and setting them in state -----
  const getAllRoles = async () => {
    try {
      let allRoleResponse = await getActiveRoles();
      allRoleResponse = allRoleResponse.data.data;
      if (userType !== "Admin") {
        const filteredRoles = [];
        for (let i = 0; i < allRoleResponse.length; i++) {
          const item = allRoleResponse[i];
          const roleName = item?.roleName;
          if (roleName !== "Customer" && roleName !== "Admin") {
            filteredRoles.push(item);
          }
        }
        allRoleResponse = filteredRoles;
      }
      setUserRole(allRoleResponse);
    } catch (error) {
      console.log(error);
    }
  };


  // Getting agency data based on agency type when userType is 'Admin'
  const getAllAgencyTypesData = useCallback(async () => {
    if (userType === "Admin") {
      try {
        const allData = await getAgencyByAgencytypeResponse(RecruitmentParterId, {
          type: selectAgencyType,
        });

        setAgencTypeData(allData?.data?.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [RecruitmentParterId, selectAgencyType]);

  const geAllAgencyType = async () => {

    try {
      const allAgency = await getAgencyType();

      setAgencies(allAgency.data.data);

    } catch (error) {
      console.log(error);
    }

  };

  // useEffect to trigger fetching agency data when selectAgencyType changes
  useEffect(() => {
    if (selectAgencyType) {
      getAllAgencyTypesData();
    }
  }, [getAllAgencyTypesData, selectAgencyType, RecruitmentParterId]);


  // Getting all recruiters and filter them based on approval status and userType
  const getAllRecruiters = async (params) => {
    const { tab, clearFilters = false } = params;

    const filters = clearFilters ? {
      isPending: false,
      isApproved: false,
      isRevoked: false,
      code: "",
      size: paginationState.pageSize,
      page: paginationState.page,
      filters: {
        firstName: appliedFilter?.firstName || "",
        lastName: appliedFilter?.lastName || "",
        email: appliedFilter?.email || "",
        userRole: appliedFilter?.userRole?.id || "",
      }
    } : {
      isPending: false,
      isApproved: false,
      isRevoked: false,
      code: "",
      size: paginationState.pageSize,
      page: paginationState.page,
      filters: {
        firstName: "",
        lastName: "",
        email: "",
        userRole: "",
      }

    }
    let payload = filters;

    tab === "Revoked" ? payload.isRevoked = true : tab === "Approved" ? payload.isApproved = true : payload.isPending = true
    let approved = "", revoked = "", notApproved = "";
    if (userType === "Admin") {
      setisDataLoaded(false);
      payload.filters.organizationName = appliedFilter?.organizationName?.id || ""
      try {
        let allRecruiters = await getAllRecruitersResponsetab(payload);
        setTotalCount(allRecruiters.data.totalCount)
        if (tab === "Approved") {
          approved = allRecruiters.data.data;;
        }
        if (tab === "Revoked") {
          revoked = allRecruiters.data.data;;
        }
        if (tab === "Pending") {
          notApproved = allRecruiters.data.data;
        }
      }
      catch (error) {
        console.log("error", error);
      }
      setallNotApprovedRecruiters(notApproved);
      setallapprovedRecruiters(approved);
      setallRevokedRecruiters(revoked);
      setisDataLoaded(true);
    }
    else {
      setisDataLoaded(false);
      payload.code = userRecords?.recruitmentpartner?.code;
      try {
        let allRecruiters = await getAllRecruitersResponsetab(payload);
        setAllOrganization(userRecords?.recruitmentpartner?.name);
        setSelectedAgency(userRecords?.agency?.agencyName);
        setSelectAgencyType(userRecords?.agency?.agencyType?.code)
        setrecruiterInfo({ ...recruiterInfo, patnerId: userRecords?.recruitmentpartner?.id, agencyId: userRecords?.agency?.id, orgCode: userRecords?.recruitmentpartner?.code })
        setTotalCount(allRecruiters.data.totalCount)
        if (tab === "Approved") {
          approved = allRecruiters.data.data;
        }
        if (tab === "Revoked") {
          revoked = allRecruiters.data.data;
        }
        if (tab === "Pending") {
          notApproved = allRecruiters.data.data;
        }
      }
      catch (error) {
        console.log("error", error);
      }
      setallNotApprovedRecruiters(notApproved);
      setallapprovedRecruiters(approved);
      setallRevokedRecruiters(revoked);
      setisDataLoaded(true);
    }
  };

  // Approving a recruiter based on the user's role (Admin or Recruiter)
  const approveRecruiterHandler = async () => {
    setApvBtn(true);
    let payload = {
      userid: recruiterData.id,
      approval: true,
      recruitmentpartnerId: userType === "Admin" ? recruiterData.organizationId : recruiterInfo.patnerId,
      roleId: recruiterData.userRole,
      roleCode: recruiterData.roleCode,
      agencyId: userType === "Admin" ? selectedAgency?.id : recruiterInfo.agencyId,
      approvedBy: idContextTest,
      recruitmentpartnerCode: recruiterInfo.orgCode,
      userType: userType,
    };

    try {
      if (
        // isRecruiter &&
        payload.recruitmentpartnerId &&
        payload.roleId &&
        selectAgencyType &&
        selectedAgency
      ) {
        let acceptRecruiter = await approveRecruitersResponse(payload);
        await getAllRecruiters({ tab: tabName });
        setOpenApproveDialogue(false);
        if (acceptRecruiter.status === 208 || acceptRecruiter.status === 200 || acceptRecruiter.status === 202 || acceptRecruiter.status === 500) {
          NotificationManager.error(
            `${acceptRecruiter.data.message}`,
            "Error",
            10000
          );
          setApvBtn(false);
        } else {
          NotificationManager.success(
            `${acceptRecruiter.data.message}`,
            "Success",
            10000
          );

          if (userType === "Admin") {
            setAllOrganization([]);
            setSelectedAgency(null);
            setSelectAgencyType(null);
            setSelectedAgency(null);
            setAgencTypeData([]);
            setSelectedAgency(null);
          }
        }
      }
      else {
        setOpenApproveDialogue(true);
        NotificationManager.error("Please select all fields", "Error", 10000);
        setApvBtn(false);
      }
    } catch (error) {
      setOpenApproveDialogue(false);
      NotificationManager.error("Approval failed", "Error", 10000);
      setApvBtn(false);
    }
  };

  // ------------------- Revoke Recuiter Dialog Box Button Function -------------

  const revokeRecruiterHandler = async () => {
    setApvBtn(true);
    let payload = {
      userid: recruiterData.id,
      approval: false,
      recruitmentpartnerId: recruiterData.organizationId,
      //new parameters
      roleId: recruiterData.userRole,
      roleCode: recruiterData.code,
      approvedBy: idContextTest,
    };
    try {
      // Sending false value to isApproved via approveRecruiter API
      // let revokeRecruiter =
      await approveRecruitersResponse(payload);
      await getAllRecruiters({ tab: tabName });
      NotificationManager.success("Recruiter revoked", "Success", 10000);
    } catch (error) {
      NotificationManager.error("Revoking failed", "Error", 10000);
    }
    setOpenRevokeDialogue(false);
    setApvBtn(false);
  };

  //-------------------------------- END -------------------------------

  const tabClicked = (name) => {
    if (!isDataLoaded) return;
    setallNotApprovedRecruiters([]);
    setallapprovedRecruiters([]);
    setallRevokedRecruiters([]);
    settabName(name);
    getAllRecruiters({ tab: name, clearFilter: true });
    setPaginationState({ page: 1, pageSize: 10 });
    setFilterValue({})
  };

  const openApproveModal = async (e, value) => {
    setRecruiterData(value);

    // If userType is Admin, get all organization else it will use the selected organization
    if (userType === "Admin") {
      await getOrganization();
    }
    setEmail(value.email);
    setApvBtn(false);
    setOpenApproveDialogue(true);
  };


  const closeApproveModal = () => {
    setRecruiterData({});
    setOpenApproveDialogue(false);
    // Removing the selected values when the modal is closed only for admin 
    if (userType === "Admin") {
      setSelectedAgency(null);
    }

    setRecruitmentParterId("");
  };

  // --------------------- Revoke Modal Open----------------

  const openRevokeModal = async (e, value) => {
    setRecruiterData(value);
    if (userType === "Admin") {
      await getOrganization();
    }
    setEmail(value.email);
    setApvBtn(false);
    setOpenRevokeDialogue(true);
  };
  const closeRevokeModal = () => {
    setRecruiterData({});
    setOpenRevokeDialogue(false);
  };
  //-------------------------------- END -------------------------------

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getAllRoles();

        await geAllAgencyType();
        if (userType === "Admin") {
          await getOrganization()
        }
      } catch (error) {
        setisDataLoaded(true);
      }
    }
    fetchAllData();
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getAllRecruiters({ tab: tabName });
      } catch (error) {
        setisDataLoaded(true);
      }
    }
    fetchAllData();
  }, [paginationState.page, paginationState.pageSize]);

  const userRoleChangeHandler = (e, value) => {
    /* Get User role from here */
    if (value) {
      setRecruiterData((item) => ({
        ...item,
        userRole: value.id,
        roleCode: value.code
      }));
    }
  };

  const userRoleChanger = (e, value) => {
    if (value === "") {
      setRecruiterData((item) => ({
        ...item,
        userRole: undefined,
      }));
    }
  };

  const organizationChangeHandler = (e, value) => {
    /** Get user recruitment parner id from here */
    if (value) {
      setRecruitmentParterId(value?.id);
      setrecruiterInfo({ ...recruiterInfo, orgCode: value.code })
      setRecruiterData((item) => ({
        ...item,
        organizationId: value.id,
      }));
      setSelectedAgency(null)
    }
  };
  const onAgencyChange = (e, value) => {
    setSelectAgencyType(value?.code || "");
    setSelectedAgency(null)
  };

  const organizationChanger = (e, value) => {
    if (value === "") {
      setRecruiterData((item) => ({
        ...item,
        organizationId: undefined,
      }));
    }
  };

  useEffect(() => {
    if (!selectAgencyType) {
      setSelectedAgency(null);
    }
  }, [selectAgencyType]);
  const internalExternalChangeHandler = (e, value) => {
    setSelectedAgency(value);
  };

  const getOrganization = async () => {
    let allOrganization = await getAllActiveRecruitmentpartner();
    setAllOrganization(allOrganization.data.data);
  };

  const goToDashboard = () => {
    // Move to dashboard based on the user type
    if (userType === "Admin") {
      history("/admin-home");
    }
    else {
      history("/dashboard");
    }
  }
  // Filter's handlers


  const filterHandler = (event, field, value) => {
    let value1 = value || event?.target?.value
    setFilterValue({ ...filterValue, [field]: value1 })
  }



  const exportToExcel = async (tab) => {

    setIsExporting(true);
    try {
      let exportArr = [];
      const pageCount = Math.ceil(totalCount / 100)

      for (let i = 0; i < pageCount; i++) {
        const payload = {
          isPending: false,
          isApproved: false,
          isRevoked: false,
          code: "",
          size: 100,
          page: i + 1,
          filters: {
            firstName: appliedFilter?.firstName || "",
            lastName: appliedFilter?.lastName || "",
            email: appliedFilter?.email || "",
            userRole: appliedFilter?.userRole?.id || "",
          }
        };


        if (tabName === "Revoked") payload.isRevoked = true;
        else if (tabName === "Approved") payload.isApproved = true;
        else payload.isPending = true;

        if (userType === "Admin") {
          payload.filters.organizationName = appliedFilter?.organizationName?.id || ""
        } else {
          payload.code = userRecords?.recruitmentpartner?.code || "";
        }

        const allRecruiters = await getAllRecruitersResponsetab(payload);
        if (allRecruiters) {
          exportArr.push(allRecruiters.data?.data || []);
        }
      }
      if (exportArr.length < 0) {
        setIsExporting(false);
        NotificationManager.error("No data present", "Error", 10000);

      }
      exportArr = exportArr.flat();
      let exportToExcel = [];
      if (tabName === "Pending") {
        exportToExcel = exportArr.map((item) => ({
          "First Name": item?.firstName || "",
          "Last Name": item?.lastName || "",
          email: item?.email || "",
          "User Role": item?.role?.roleName || "",
          "Recruitment Organization": item?.organizationnameduringsignup || "",
          "Phone Number": item?.phoneNumber || "",
          Country: item?.profile?.locationCountry ? JSON.parse(item?.profile?.locationCountry)?.name || "N/A" : "N/A",
          "Request Date": item?.createdAt?.split("T")[0] || ""
        }));
      } else if (tabName === "Approved") {
        exportToExcel = exportArr.map((item) => ({
          "First Name": item?.firstName || "",
          "Last Name": item?.lastName || "",
          email: item?.email || "",
          "User Role": item?.role?.roleName || "",
          "Recruitment Organization": item?.recruitmentpartner?.name || "",
          Agency: item?.agency?.agencyName || "",
          "Agency Type": item?.agency?.agencyType?.name || "",
          "Community Size": (item?.myCandidates && item?.myCandidates?.length > 0) ? item?.myCandidates.length : "0",
          "Phone Number": item.phoneNumber || "",
          Country: item?.profile?.locationCountry ? JSON.parse(item?.profile?.locationCountry)?.name || "N/A" : "N/A",
          "Approve On": item?.approvalDate?.split("T")[0] || "",
          Status: item?.isActive ? "Active" : "Inactive"
        }));
      } else if (tabName === "Revoked") {
        exportToExcel = exportArr.map((item) => ({
          "First Name": item?.firstName || "",
          "Last Name": item?.lastName || "",
          email: item?.email || "",
          "Recruitment Organization": item?.organizationnameduringsignup || "",
          Agency: item?.agency ?? "N/A",
          "Phone Number": item?.phoneNumber || "",
          Country: item?.profile?.locationCountry ? JSON.parse(item?.profile?.locationCountry)?.name || "N/A" : "N/A"
        }));
      }
      // Lazy load XLSX only when needed for export
      const { utils, writeFile } = await import("xlsx");
      const ws = utils.json_to_sheet(exportToExcel);
      if (ws) {
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        writeFile(wb, "CustomerSignUpRequest.xlsx");
      }
      setIsExporting(false);
    } catch (error) {
      console.log(error, "err");
    }
  };


  const filterSearch = async () => {
    setAppliedFilter(filterValue)
    setPaginationState({ ...paginationState, page: 1 });
    setisDataLoaded(false);
    if (tabName === "Pending") {
      setallNotApprovedRecruiters([])
    } else if (tabName === "Approved") {
      setallapprovedRecruiters([])
    } else if (tabName === "Revoked") {
      setallRevokedRecruiters([])
    }
    const payload = {
      isPending: false,
      isApproved: false,
      isRevoked: false,
      code: "",
      size: paginationState.pageSize,
      page: 1,
      filters: {
        firstName: filterValue?.firstName,
        lastName: filterValue?.lastName,
        email: filterValue?.email,
        userRole: filterValue?.userRole?.id || "",
      }

    }
    if (tabName === "Revoked") payload.isRevoked = true;
    else if (tabName === "Approved") payload.isApproved = true;
    else payload.isPending = true;
    if (userType === "Admin") {
      payload.filters.organizationName = filterValue?.organizationName?.id || ""
    } else {
      payload.code = userRecords?.recruitmentpartner?.code;
    }

    try {
      let data = await getAllRecruitersResponsetab(payload);

      setisDataLoaded(true);
      if (tabName === "Pending") {
        setallNotApprovedRecruiters(data?.data?.data)
        setTotalCount(data?.data?.totalCount)
      } else if (tabName === "Approved") {
        setallapprovedRecruiters(data?.data?.data)
        setTotalCount(data?.data?.totalCount)
      } else if (tabName === "Revoked") {
        setallRevokedRecruiters(data?.data?.data)
        setTotalCount(data?.data?.totalCount)
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  return (
    <>
      {userType === "Admin" || userType === "MIS Operator" || userType === "Organization Admin" ? (
        <div className="signupReq_mainContainer">
          <div className="communityHeader_signup-req ">
            <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
              <Tooltip title="Go Back to Dashboard" placement="bottom">
                <ArrowBackIcon sx={{ fontSize: 20 }} />
              </Tooltip>
              {/* <span>&nbsp;Go Back to Dashboard</span> */}
            </div>
            <div className="communityTitle">Sign-Up Requests</div>

          </div>
          <div className="mainContainer_recruiter">

            <div className="filterContainer_recruiter">
              <div className="top-search-bar">
                <div className="top-search-text">
                  <div className="query-label">
                    <span className="query-value">Showing Results : {tabName}</span>
                  </div>
                </div>
                <button
                  variant="contained"
                  color="primary"
                  className="search-btn"
                  onClick={filterSearch}
                >
                  Search
                </button>
              </div>
              <div className="advanced-search-wrapper">
                <div className="filter-box">
                  <label className="filter-label">First Name</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter First Name"
                      className="outline_textbox_recruiter"
                      value={filterValue.firstName || ""}
                      onChange={(e) => filterHandler(e, "firstName")}
                    />
                  </FormControl>
                </div>
                <div className="filter-box">
                  <label className="filter-label">Last Name</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter Last Name"
                      className="outline_textbox_recruiter"
                      value={filterValue.lastName || ""}
                      onChange={(e) => filterHandler(e, "lastName")}
                    />
                  </FormControl>
                </div>
                <div className="filter-box">
                  <label className="filter-label">Email</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter Email"
                      className="outline_textbox_recruiter"
                      value={filterValue.email || ""}
                      onChange={(e) => filterHandler(e, "email")}
                    />
                  </FormControl>
                </div>
                {tabName === "Pending" || tabName === "Revoked" ? null : <>
                  <div className="filter-box">
                    <label className="filter-label">User Role</label>
                    <Autocomplete
                      options={userRole}
                      getOptionLabel={(option) => option.roleName || ""}
                      value={filterValue.userRole}
                      onChange={(e, value) => filterHandler(e, "userRole", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select User Role"
                        />
                      )}
                    />
                  </div>
                </>}
                {userType === "Admin" ?
                  <div className="filter-box">
                    <label className="filter-label">Recruitment Organization</label>
                    <Autocomplete
                      options={AllOrganization}
                      filterOptions={filterOptions}
                      getOptionLabel={(option) => option.name || ""}
                      value={filterValue.organizationName}
                      onChange={(e, value) => filterHandler(e, "organizationName", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Recruitment Organization"
                        />
                      )}
                    />
                  </div>
                  : null}
              </div>
            </div>
            <div className="rightSideMainContainer_recruiter">
              <div className="tab_header">

                <div className="tabButtonContainer">
                  <div
                    className={`tabButton ${tabName === "Pending" ? "tabActive" : ""
                      }`}
                    onClick={() => tabClicked("Pending")}
                  >
                    Pending
                  </div>
                  <div
                    className={`tabButton ${tabName === "Approved" ? "tabActive" : ""
                      }`}
                    onClick={() => tabClicked("Approved")}
                  >
                    Approved
                  </div>
                  <div
                    className={`tabButton ${tabName === "Revoked" ? "tabActive" : ""
                      }`}
                    onClick={() => tabClicked("Revoked")}
                  >
                    Revoked
                  </div>
                </div>
                <div className="ExportButton_Container">
                  <button onClick={exportToExcel} className="exportExcelBtn">
                    <Excel size={30} className='excelImg_recruiter' alt="excelImg" />

                    <span>Export</span>
                  </button>
                </div>
              </div>
              <div className="containerMain">
                <Backdrop sx={stylesSX.backdrop} open={isExporting}>
                  <CircularProgress color="inherit" />
                  <Typography sx={stylesSX.waitingText}>
                    {" "}
                    Please wait ...
                  </Typography>
                </Backdrop>
                {tabName === "Approved" ? (
                  <AllapprovedRecruitersKendoTable
                    allapprovedRecruiters={allapprovedRecruiters}
                    isDataLoaded={isDataLoaded}
                    userType={userType}
                    paginationState={paginationState}
                    setPaginationState={setPaginationState}
                    totalCount={totalCount}
                  />
                ) : tabName === "Revoked" ? (
                  <AllRevokedRecruitersKendoTable
                    allRevokedRecruiters={allRevokedRecruiters}
                    isDataLoaded={isDataLoaded}
                    paginationState={paginationState}
                    setPaginationState={setPaginationState}
                    totalCount={totalCount}
                  />
                ) : (
                  <AllNotApprovedRecruitersKendoTable
                    allNotApprovedRecruiters={allNotApprovedRecruiters}
                    approveRecruiterHandler={openApproveModal}
                    revokeRecruiterHandler={openRevokeModal}
                    isDataLoaded={isDataLoaded}
                    paginationState={paginationState}
                    setPaginationState={setPaginationState}
                    totalCount={totalCount}
                  />
                )}
              </div>
            </div>
          </div>

          <Dialog
            open={openApproveDialogue}
            onClose={closeApproveModal}
            aria-labelledby="customized-dialog-title"
            className="approveRecruiterModal"
          >
            <Grid size={{ xs: 12 }}>
              <div className="Recruiter_Private_Skill_Modal_">
                <DialogTitle
                  id="customized-dialog-title"
                  className="admindailog_title_modal"
                  onClose={closeApproveModal}
                >
                  <div className="dialog-title-container">

                    <VerifiedUserIcon className="iconStyle" />
                    <span className="dialog-title-text">Approve Sign-up Request</span>
                  </div>
                </DialogTitle>
              </div>
            </Grid>

            {
              userType === "Admin" ?
                <>
                  <DialogContent
                    className="removemodal_responsive"

                  >
                    <>
                      <div className="select customized-select options">
                        <label className="field_name" htmlFor="country">
                          User Role*
                        </label>
                        <Autocomplete
                          autoSelect
                          id="combo-box-demo"
                          className="mt_8"
                          options={userRole}
                          getOptionLabel={(option) => option.roleName || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select User Type"
                            />
                          )}
                          onChange={userRoleChangeHandler}
                          onInputChange={userRoleChanger}
                        />
                      </div>
                      <div className="select customized-select options">
                        <label className="field_name" htmlFor="country">
                          Recruitment Organization*
                        </label>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_8"
                          options={AllOrganization}
                          autoHighlight
                          // defaultValue={RecruitmentParterId}
                          filterOptions={filterOptions}
                          getOptionLabel={(option) => option.name || ""}
                          onChange={organizationChangeHandler}
                          onInputChange={organizationChanger}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select Recruitment Organization"
                            />
                          )}
                        />
                      </div>

                      {/* {isRecruiter && (
          <> */}
                      <div className="select customized-select options">
                        <label className="field_name" htmlFor="country">
                          Agency Type*
                        </label>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_8"
                          options={agencies}
                          autoHighlight
                          filterOptions={filterOptions}
                          getOptionLabel={(option) => option.code || ""}
                          onChange={onAgencyChange}
                          onInputChange={organizationChanger}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select Agency Type"
                            />
                          )}
                        />
                      </div>
                      <div className="select customized-select options">
                        <label className="field_name" htmlFor="country">
                          Agency*
                        </label>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_8"
                          options={agencyTypeData ? agencyTypeData : []}
                          value={selectedAgency}
                          autoHighlight
                          // filterOptions={filterOptions}
                          getOptionLabel={(option) => option?.agencyName || ""}
                          onChange={internalExternalChangeHandler}
                          // onInputChange={organizationChanger}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder={` select ${selectAgencyType} Agency `}
                            />
                          )}
                        />
                      </div>
                      {/* </>
        )} */}
                    </>
                    <div className="text-center fs-semi-bold f-color fs-18 mt_20">
                      Do you want to approve the Sign Up of the customer ({email}) ?
                    </div>
                  </DialogContent>
                </> :
                <>
                  <DialogContent
                    className="removemodal_responsive"
                  >
                    <>
                      <div className="select customized-select options">
                        <label className="field_name MuiTypography-root field-title-team-dialog MuiTypography-body1" htmlFor="country">
                          User Role*
                        </label>
                        <Autocomplete
                          autoSelect
                          id="combo-box-demo"
                          className="mt_10"
                          options={userRole}
                          getOptionLabel={(option) => option.roleName || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select User Type"
                            />
                          )}
                          onChange={userRoleChangeHandler}
                          onInputChange={userRoleChanger}
                        />
                      </div>
                      <div className="select customized-select options">
                        <label className="field_name MuiTypography-root field-title-team-dialog MuiTypography-body1" htmlFor="country">
                          Recruitment Organization*
                        </label>

                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            placeholder="Org code"
                            className="userDetails_textbox_outline mt_8"
                            value={AllOrganization}
                            // onChange={(e) => firstNameChange(e)}
                            disabled={true}
                          />
                        </FormControl>

                      </div>


                      <div className="select customized-select options">
                        <label className="field_name MuiTypography-root field-title-team-dialog MuiTypography-body1" htmlFor="country">
                          Agency Type*
                        </label>

                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            placeholder="Org code"
                            className="userDetails_textbox_outline mt_8"
                            value={selectAgencyType}
                            // onChange={(e) => firstNameChange(e)}
                            disabled={true}
                          />
                        </FormControl>

                      </div>
                      <div className="select customized-select options">
                        <label className="field_name MuiTypography-root field-title-team-dialog MuiTypography-body1" htmlFor="country">
                          Agency*
                        </label>
                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            placeholder="Org code"
                            className="userDetails_textbox_outline mt_8"
                            value={selectedAgency}
                            // onChange={(e) => firstNameChange(e)}
                            disabled={true}
                          />
                        </FormControl>

                      </div>

                    </>
                    <div className="text-center fs-semi-bold f-color fs-18 mt_20">
                      Do you want to approve the Sign Up of the customer ({email}) ?
                    </div>
                  </DialogContent>
                </>
            }

            <DialogActions
              className="responsiveRemove_Modal_button"
            >
              <div className="remove_modal revoke_adjust">
                <button
                  type="button"
                  className="btn_remove btn4 btn-skill cp"
                  onClick={closeApproveModal}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn4 btn_primary ml_5 cp"
                  onClick={approveRecruiterHandler}
                  disabled={apvBtn}
                >
                  <div className="btn_loader">
                    Yes
                    &nbsp;
                    {apvBtn &&
                      <div>
                        <CircularProgress size={13} />
                      </div>
                    }
                  </div>
                </button>
              </div>
            </DialogActions>
          </Dialog>

          {/* -------------------    Confirmation Dialog Box for Revoking Recruiters -------------- */}

          <Dialog
            open={openRevokeDialogue}
            onClose={closeRevokeModal}
            aria-labelledby="customized-dialog-title"
          >
            <DialogContent
              className="removemodal_responsive"
            >
              <div className="text-center fs-semi-bold f-color fs-18 mt_20">
                Do you want to revoke this customer ({email}) ?
              </div>
            </DialogContent>
            <DialogActions
              className="responsiveRemove_Modal_button"
            >
              <div className="remove_modal revoke_adjust">
                <button
                  type="button"
                  className="btn_remove btn4 btn-skill cp"
                  onClick={closeRevokeModal}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn4 btn_primary ml_5 cp"
                  onClick={revokeRecruiterHandler}
                  disabled={apvBtn}
                >
                  <div className="btn_loader">
                    Yes
                    &nbsp;
                    {apvBtn &&
                      <div>
                        <CircularProgress size={13} />
                      </div>
                    }
                  </div>
                </button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      ) : (
        <UnauthorizedAccess />
      )
      }
    </>
  );
};

export default Recruiters;
